import type { ErrorLike } from '@apollo/client'
import { CombinedGraphQLErrors } from '@apollo/client/errors'

/** A failed optional summary must not make an otherwise loaded Post unusable. */
export function isOptionalNotesSummaryError(
  error: ErrorLike | undefined,
): boolean {
  return (
    !!error &&
    CombinedGraphQLErrors.is(error) &&
    error.errors.length > 0 &&
    error.errors.every(({ path }) =>
      path?.includes('collaborationNotesSummary'),
    )
  )
}
